"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import Link from "next/link";
import { cicToType } from "@/helpers/Helpers";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ArtistSubmissionBadge } from "@/components/waves/drops/ArtistSubmissionBadge";
import { ArtistPreviewModal } from "@/components/waves/drops/ArtistPreviewModal";
import { ProfileWinnerBadge } from "@/components/waves/drops/ProfileWinnerBadge";
interface MemeDropArtistInfoProps {
  readonly drop: ExtendedDrop;
}
export default function MemeDropArtistInfo(t0) {
  const $ = _c(44);
  const {
    drop
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const submissionCount = drop.author.active_main_stage_submission_ids?.length || 0;
  const hasSubmissions = submissionCount > 0;
  const isWinner = drop.author.winner_main_stage_drop_ids && drop.author.winner_main_stage_drop_ids.length > 0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsModalOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleSubmissionBadgeClick = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsModalOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleModalClose = t2;
  let t3;
  if ($[2] !== drop) {
    t3 = <WaveDropAuthorPfp drop={drop} />;
    $[2] = drop;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== drop.author.cic || $[5] !== drop.author.level) {
    t4 = !!drop.author?.level && <UserCICAndLevel level={drop.author.level} cicType={cicToType(drop.author.cic)} size={UserCICAndLevelSize.SMALL} />;
    $[4] = drop.author.cic;
    $[5] = drop.author.level;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `/${drop.author?.handle}`;
  let t6;
  if ($[7] !== drop.author.handle || $[8] !== drop.author.id) {
    t6 = drop.author?.handle ? <UserProfileTooltipWrapper user={drop.author.handle ?? drop.author.id}><span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold">{drop.author?.handle}</span></UserProfileTooltipWrapper> : <span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold">{drop.author?.handle}</span>;
    $[7] = drop.author.handle;
    $[8] = drop.author.id;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <Link href={t5} onClick={_temp} className="tw-no-underline">{t6}</Link>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isWinner) {
    t8 = isWinner && <ProfileWinnerBadge winCount={1} />;
    $[13] = isWinner;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== drop.id || $[16] !== hasSubmissions || $[17] !== submissionCount) {
    t9 = hasSubmissions && <ArtistSubmissionBadge submissionCount={submissionCount} onBadgeClick={handleSubmissionBadgeClick} tooltipId={`meme-badge-${drop.id}`} />;
    $[15] = drop.id;
    $[16] = hasSubmissions;
    $[17] = submissionCount;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" />;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== drop.created_at) {
    t11 = <WaveDropTime timestamp={drop.created_at} />;
    $[20] = drop.created_at;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = drop.winning_context?.decision_time ?? null;
  let t13;
  if ($[22] !== drop.rank || $[23] !== t12) {
    t13 = <div className="tw-ml-2"><WinnerDropBadge rank={drop.rank} decisionTime={t12} /></div>;
    $[22] = drop.rank;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t11 || $[26] !== t13 || $[27] !== t4 || $[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
    t14 = <div className="tw-flex tw-items-center tw-gap-x-2">{t4}{t7}{t8}{t9}{t10}{t11}{t13}</div>;
    $[25] = t11;
    $[26] = t13;
    $[27] = t4;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== drop.wave) {
    t15 = drop.wave && <Link onClick={_temp2} href={`/waves?wave=${drop.wave.id}`} className="tw-mb-0 tw-text-[11px] tw-leading-0 tw-text-iron-500 hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out tw-no-underline">{drop.wave.name}</Link>;
    $[32] = drop.wave;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t14 || $[35] !== t15) {
    t16 = <div className="tw-flex tw-flex-col tw-gap-y-1.5">{t14}{t15}</div>;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== drop.author || $[38] !== isModalOpen) {
    t17 = <ArtistPreviewModal isOpen={isModalOpen} onClose={handleModalClose} user={drop.author} />;
    $[37] = drop.author;
    $[38] = isModalOpen;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t16 || $[41] !== t17 || $[42] !== t3) {
    t18 = <div className="tw-flex tw-items-center tw-gap-x-3">{t3}{t16}{t17}</div>;
    $[40] = t16;
    $[41] = t17;
    $[42] = t3;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}